export default __webpack_public_path__ + "static/media/hero.1cc2b113.png";